import { PropsWithChildren } from 'react';

import { Heading4 } from '@ui';

import * as css from './ActivityListTag.css';

import type { TagState } from './ActivityListTag.css';

type ActivityListTagProps = {
    state?: TagState;
};

export const ActivityListTag = ({ state = 'default', children }: PropsWithChildren<ActivityListTagProps>) => {
    return (
        <div className={css.tag({ state })}>
            <Heading4 color={state === 'primary' ? 'inverse' : 'primary'}>{children}</Heading4>
        </div>
    );
};
